// methods here build URLs for site pages

import utilityService from './utilityService.js'
import gridUtils from './gridUtils.js'
import deepCopyService from './deepCopyService.js'

export default {
    mixins: [utilityService, gridUtils, deepCopyService],
    methods: {

        // returns numbers of first two adjacent columns which include tabby, or an empty array if none doe
        getOvershotTreadleNumbers(tieupArray, treadlingArray) {
            // first separate the treadling into four groups, every 4th treadle starting with 1, 2, 3, and 4
            // if the pattern is overshot, either groups 1 and 3 must be opposing tabby, or groups 2 and 4 must be opposing tabby with all the same treadles in each group
            // and the other groups must not contain any of the tabby treadles

            let group1 = []
            let group2 = []
            let group3 = []
            let group4 = []

            // console.log('treadlingArray: ' + JSON.stringify(treadlingArray))

            for (let pickNum=0; pickNum < treadlingArray.length; pickNum++) {
                let treadleNumber = this.firstDepressedTreadleNumber(pickNum, treadlingArray)
                if (pickNum % 4 === 0) {
                    group1.push(treadleNumber)
                }
                else if (pickNum % 4 === 1) {
                    group2.push(treadleNumber)
                }
                else if (pickNum % 4 === 2) {
                    group3.push(treadleNumber)
                }
                else if (pickNum % 4 === 3) {
                    group4.push(treadleNumber)
                }
            }
            /*
            // console.log('treadlingArray: ' + JSON.stringify(treadlingArray))
            // console.log('group1: ' + JSON.stringify(group1))
            // console.log('group2: ' + JSON.stringify(group2))
            // console.log('group3: ' + JSON.stringify(group3))
            // console.log('group4: ' + JSON.stringify(group4))
            // console.log('tieupArray: ' + JSON.stringify(tieupArray))
            */
            let tabbyTreadleNumbers = []

            if (this.allTreadlesSameInGroup(group1) && this.allTreadlesSameInGroup(group3) && !this.allTreadlesSameInGroup(group2) && !this.allTreadlesSameInGroup(group4)) {
                // tabby could be on group 1 or group 3
                let firstTreadleNum = group1[0]
                let secondTreadleNum = group3[0]

                // console.log('tabbyTreadNumbers1-3: ' + firstTreadleNum + ', ' + secondTreadleNum)

                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, false) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, true)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, true) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, false)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
            }
            else if (this.allTreadlesSameInGroup(group2) && this.allTreadlesSameInGroup(group4) && !this.allTreadlesSameInGroup(group1) && !this.allTreadlesSameInGroup(group3)) {
                // tabby could be on group 2 or group 4
                let firstTreadleNum = group2[0]
                let secondTreadleNum = group4[0]

                // console.log('tabbyTreadNumbers2-4: ' + firstTreadleNum + ', ' + secondTreadleNum)

                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, false) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, true)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, true) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, false)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
            }
            // console.log('tabby treadle numbers: ' + tabbyTreadleNumbers)
            return tabbyTreadleNumbers
        },

        everyOtherShaftRaised(tieupArray, columnNumber, evenNumbers) {
            // first try treadles 0 and 1
            // let totalShafts = tieupArray.length
            let col = columnNumber
            let shaftNumber = evenNumbers ? 0 : 1
            for (shaftNumber; shaftNumber < tieupArray.length; shaftNumber+=2) {
                let row = shaftNumber
                if (!tieupArray[row][col]) {
                    return false
                }
            }
            return true
        },

        allTreadlesSameInGroup(treadleNumbersArray) {
            if (treadleNumbersArray.length < 2) {
                return false
            }
            for (let i=1; i<treadleNumbersArray.length; i++) {
                if (treadleNumbersArray[i] !== treadleNumbersArray[i-1]) {
                    return false
                }
            }
            return true
        },

        firstDepressedTreadleNumber(pickNumber, treadlingArray) {
            let rowNumber = pickNumber
            let treadlesCount = treadlingArray[0].length
            for (let treadleNum = 0; treadleNum < treadlesCount; treadleNum++) {
                let colNumber = treadleNum
                if (treadlingArray[rowNumber][colNumber]) {
                    return treadleNum
                }
            }
        },

        getDraftTableCellStyles(cellPixelSizeVal, includeRightPadding, includeBottomPadding) {
            let tdStyle = ''
            let pr ='0px'
            let pb='0px'
            if (includeRightPadding) {
                pr = cellPixelSizeVal + 'px'
            }
            if (includeBottomPadding) {
                pb = cellPixelSizeVal + 'px'
            }
            tdStyle = { paddingRight: pr, paddingBottom: pb }
            return tdStyle
        },

        getRemPixels() {
            let div = this.$refs.sizingDiv
            div.style.height = '0.75rem'
            let remPixels = div.offsetHeight
            div.style.height = '0'
            return remPixels
        },

        analyzeColors(warpThreadsArray, weftThreadsArray, darkestColor, lightestColor) {
            let darkestColorFound = { R: 255, G: 255, B: 255 }
            let lightestColorFound = { R: 0, G: 0, B: 0 }
            let allColorsList = {}
            let warpColorsList = {}
            let weftColorsList = {}

            for (let i=0; i < warpThreadsArray.length; i++) {
                let color = warpThreadsArray[i]
                let lightDarkValue = this.colorLightDarkValue(color)
                if (lightDarkValue < this.colorLightDarkValue(darkestColorFound)) {
                    darkestColorFound = color
                }
                if (lightDarkValue > this.colorLightDarkValue(lightestColorFound)) {
                    lightestColorFound = color
                }
                let colorKey = this.colorKeyString(color)
                allColorsList[colorKey] = color
                warpColorsList[colorKey] = color
            }

            for (let i=0; i < weftThreadsArray.length; i++) {
                let color = weftThreadsArray[i]
                let lightDarkValue = this.colorLightDarkValue(color)
                if (lightDarkValue < this.colorLightDarkValue(darkestColorFound)) {
                    darkestColorFound = color
                }
                if (lightDarkValue > this.colorLightDarkValue(lightestColorFound)) {
                    lightestColorFound = color
                }
                let colorKey = this.colorKeyString(color)
                allColorsList[colorKey] = color
                weftColorsList[colorKey] = color
            }

            darkestColor.R = darkestColorFound.R
            darkestColor.G = darkestColorFound.G
            darkestColor.B = darkestColorFound.B
            lightestColor.R = lightestColorFound.R
            lightestColor.G = lightestColorFound.G
            lightestColor.B = lightestColorFound.B

            let countsObj = { allColorsCount: Object.keys(allColorsList).length, warpColorsCount: Object.keys(warpColorsList).length, weftColorsCount: Object.keys(weftColorsList).length }
            // console.log('colorsObj: ' + JSON.stringify(countsObj))
            return countsObj
        },

        colorLightDarkValue(c) {
            return c.R * c.G * c.B
        },

        colorKeyString(c) {
            return c.R + '-' + c.G + '-' + c.B
        },

        equalColors(first, second) {
            // console.log('first: ' + JSON.stringify(first))
            // console.log('second: ' + JSON.stringify(second))
            let retVal = ((first.R === second.R) && (first.G === second.G) && (first.B === second.B))
            // console.log('retVal: ' + JSON.stringify(retVal))
            return retVal
        },

        emptyDraft(shaftsCount, treadlesCount, warpThreadsCount, weftThreadsCount) {
            let newEmptyDraft = {}
            newEmptyDraft.ShaftsCount = shaftsCount
            newEmptyDraft.TreadlesCount = treadlesCount
            newEmptyDraft.WarpThreadsCount = warpThreadsCount
            newEmptyDraft.WeftThreadsCount = weftThreadsCount
            newEmptyDraft.Tieup = []
            newEmptyDraft.Threading = []
            newEmptyDraft.Treadling = []
            newEmptyDraft.WarpThreads = []
            newEmptyDraft.WeftThreads = []

            for (let t=0; t < treadlesCount; t++) {
                newEmptyDraft.Tieup.push([])
            }

            for (let w=0; w < warpThreadsCount; w++) {
                newEmptyDraft.Threading.push([])
                newEmptyDraft.WarpThreads.push({ R: 0, G: 0, B: 0 })
            }
            for (let w=0; w < weftThreadsCount; w++) {
                newEmptyDraft.Treadling.push([])
                newEmptyDraft.WeftThreads.push({ R: 255, G: 255, B: 255 })
            }
            return newEmptyDraft
        }

    }
}
